"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _axios = _interopRequireDefault(require("axios"));
var _bootstrap = require("../autoform/bootstrap");
var _reactSelect = _interopRequireDefault(require("react-select/async/dist/react-select.esm"));
var _reactSelectAsyncPaginate = _interopRequireDefault(require("react-select-async-paginate"));
var _excluded = ["url", "axiosInstance", "paginate", "valueField", "labelField"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ApiReactSelect = exports["default"] = /*#__PURE__*/function (_Component) {
  function ApiReactSelect(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ApiReactSelect);
    _this = _callSuper(this, ApiReactSelect, [props]);
    _this.state = {
      loading: false
    };
    _this.formApi = null;
    return _this;
  }
  (0, _inherits2["default"])(ApiReactSelect, _Component);
  return (0, _createClass2["default"])(ApiReactSelect, [{
    key: "mapOptions",
    value: function mapOptions(response) {
      var _this2 = this;
      return _.map(response.data.results, function (x) {
        return {
          value: x[_this2.props.valueField],
          label: x[_this2.props.labelField]
        };
      });
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(inputValue, callback) {
      var component = this;
      this.props.axiosInstance.get(this.props.url).then(function (response) {
        callback(component.mapOptions(response));
      });
    }
  }, {
    key: "pagedLoadOptions",
    value: function () {
      var _pagedLoadOptions = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(search, loaded_options, _ref) {
        var page, params, response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              page = _ref.page;
              params = {};
              params.page = page;
              _context.next = 5;
              return this.props.axiosInstance.get(this.props.url, {
                params: params
              });
            case 5:
              response = _context.sent;
              return _context.abrupt("return", {
                options: this.mapOptions(response),
                hasMore: response.data.next !== null,
                additional: {
                  page: page + 1
                }
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function pagedLoadOptions(_x, _x2, _x3) {
        return _pagedLoadOptions.apply(this, arguments);
      }
      return pagedLoadOptions;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        url = _this$props.url,
        axiosInstance = _this$props.axiosInstance,
        paginate = _this$props.paginate,
        valueField = _this$props.valueField,
        labelField = _this$props.labelField,
        rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var component = _reactSelect["default"];
      var loadOptions = this.loadOptions.bind(this);
      if (paginate) {
        component = _reactSelectAsyncPaginate["default"];
        loadOptions = this.pagedLoadOptions.bind(this);
        rest.additional = {
          page: 1
        };
      }
      return /*#__PURE__*/_react["default"].createElement(_bootstrap.BootstrapReactSelect, (0, _extends2["default"])({}, rest, {
        component: component,
        loadOptions: loadOptions,
        defaultOptions: true
      }));
    }
  }]);
}(_react.Component);
ApiReactSelect.propTypes = {
  axiosInstance: _propTypes["default"].func,
  url: _propTypes["default"].string.isRequired,
  valueField: _propTypes["default"].string.isRequired,
  labelField: _propTypes["default"].string.isRequired,
  paginate: _propTypes["default"].bool.isRequired
};
ApiReactSelect.defaultProps = {
  axiosInstance: _axios["default"],
  valueField: "slug",
  labelField: "name",
  paginate: false
};